import { createStructuredSelector } from "reselect";
import {
    OTHER_EQUIPMENT_HOSPITAL_LIST,
    OTHER_EQUIPMENT_HOSPITAL_LIST_SUCCESS,
    OTHER_EQUIPMENT_HOSPITAL_LIST_ERROR,
    OTHER_EQUIPMENT_LIST,
    OTHER_EQUIPMENT_LIST_SUCCESS,
    OTHER_EQUIPMENT_LIST_ERROR,
    OTHER_EQUIPMENT_LIST_SEARCH_CHANGE,
    OTHER_EQUIPMENT_EDIT_MODAL_SET,
    OTHER_EQUIPMENT_EDIT_CHANGE_SET,
    OTHER_EQUIPMENT_EDIT,
    OTHER_EQUIPMENT_EDIT_SUCCESS,
    OTHER_EQUIPMENT_EDIT_ERROR,
    OTHER_EQUIPMENT_EQP,
    OTHER_EQUIPMENT_EQP_SUCCESS,
    OTHER_EQUIPMENT_EQP_ERROR

} from "../../actions";

export const NAME = 'otherReassignation';


export const OtherEquipmentHospitalList = (data) => ({
    type: OTHER_EQUIPMENT_HOSPITAL_LIST,
    payload: data
});

export const OtherEquipmentHospitalListSuccess = (data) => ({
    type: OTHER_EQUIPMENT_HOSPITAL_LIST_SUCCESS,
    payload: data
});

export const OtherEquipmentHospitalListError = (error) => ({
    type: OTHER_EQUIPMENT_HOSPITAL_LIST_ERROR,
    payload: error
});

export const OtherEquipmentList = (data) => ({
    type: OTHER_EQUIPMENT_LIST,
    payload: data
});

export const OtherEquipmentListSuccess = (data) => ({
    type: OTHER_EQUIPMENT_LIST_SUCCESS,
    payload: data
});

export const OtherEquipmentListError = (error) => ({
    type: OTHER_EQUIPMENT_LIST_ERROR,
    payload: error
});

export const OtherEquipmentListSearchChange = (data) => ({
    type: OTHER_EQUIPMENT_LIST_SEARCH_CHANGE,
    payload: data
});

export const OtherEquipmentEditModalSet = (data) => ({
    type: OTHER_EQUIPMENT_EDIT_MODAL_SET,
    payload: data
});

export const OtherEquipmentEditChangeSet = (data) => ({
    type: OTHER_EQUIPMENT_EDIT_CHANGE_SET,
    payload: data
});

export const OtherEquipmentEdit = (data) => ({
    type: OTHER_EQUIPMENT_EDIT,
    payload:  data 
});

export const OtherEquipmentEditSuccess = (message) => ({
    type: OTHER_EQUIPMENT_EDIT_SUCCESS,
    payload: message
});

export const OtherEquipmentEditError = (error) => ({
    type: OTHER_EQUIPMENT_EDIT_ERROR,
    payload: error
});

export const OtherEquipmentEqp = (data) => ({
    type: OTHER_EQUIPMENT_EQP,
    payload: data
});

export const OtherEquipmentEqpSuccess = (data) => ({
    type: OTHER_EQUIPMENT_EQP_SUCCESS,
    payload: data
});

export const OtherEquipmentEqpError = (error) => ({
    type: OTHER_EQUIPMENT_EQP_ERROR,
    payload: error
});

const otherReassignation = (state) => state[NAME];

export const OtherReassignationSelector = createStructuredSelector({
    otherReassignation
})